import React from "react";
import { FiMap } from "react-icons/fi";

export default function ProjetsEmptyState() {
  return (
    <div className="rounded-[2rem] border border-dashed border-slate-300 bg-white px-6 py-12 text-center shadow-sm dark:border-slate-700 dark:bg-slate-950">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-[#1277B9]/10 text-[#1277B9] dark:bg-[#1277B9]/20 dark:text-sky-300">
        <FiMap className="h-7 w-7" />
      </div>

      <h2 className="mt-5 text-xl font-bold text-slate-950 dark:text-white">
        Aucun grand projet publié
      </h2>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-7 text-slate-600 dark:text-slate-300">
        Les projets structurants de la commune seront affichés ici dès leur
        publication.
      </p>
    </div>
  );
}